import { RunningExperiments, useExperiments } from 'state/experiments';

export const useEnableHomePageV2Experiment = (skipExposureLogging: boolean = false) => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.HomePageV2, 'treatment', {
    skipExposureLogging,
  });
};
